(ns ui.editors.simple-filters.model-schema)

(def field-path-schema
  [:or
   [:keyword {:description "Simple field key, e.g. :company-name"}]
   [:vector {:description "Nested path, e.g. [:entity :owner :name]"}
    keyword?]])

(def selection-schema
  [:map {:description "One active filter pill selection."}
   [:id {:description "Stable UI id for rendering/diffing."} string?]
   [:kind {:description "Selection kind."} [:enum :value :range :predicate]]
   [:value {:optional true
            :description "Selected option value for :value selections."} any?]
   [:from {:optional true
           :description "Range start value for :range selections."} any?]
   [:to {:optional true
         :description "Range end value for :range selections."} any?]
   [:predicate {:optional true
                :description "Predicate marker for :predicate selections."} keyword?]])

(def field-filter-schema
  [:map {:description "Applied selections for one field."}
   [:field-path {:description "Field represented by this filter."} field-path-schema]
   [:mode {:description "Field behavior mode in editor."} keyword?]
   [:selections {:description "All selected pills for the field."}
    [:vector selection-schema]]])

(def model-schema
  [:map {:description "Filters editor runtime state kept in re-frame db."}
   [:id {:description "Editor instance id."} any?]
   [:context
    [:map {:description "Data context used for loading and applying filters."}
     [:entity-type keyword?]
     [:pipeline-id any?]
     [:account-id any?]]]
   [:preference-context
    [:map {:description "Keys used for persisting user preferences."}
     [:view-id any?]
     [:pipeline-id any?]]]
   [:fields
    [:map {:description "Searchable field catalog, already access-filtered."}
     [:status keyword?]
     [:error {:optional true} any?]
     [:search-text string?]
     [:ordered-paths [:vector field-path-schema]]
     [:by-path [:map-of field-path-schema any?]]]]
   [:po
    [:map {:description "Product-owner configured defaults."}
     [:configured-field-paths [:vector field-path-schema]]
     [:visible-field-paths [:vector field-path-schema]]]]
   [:pinned
    [:map {:description "User-pinned fields and save status."}
     [:field-paths [:vector field-path-schema]]
     [:saving? boolean?]
     [:error {:optional true} any?]]]
   [:sections
    [:map {:description "Rendered chip ordering sections."}
     [:po-field-paths [:vector field-path-schema]]
     [:pinned-field-paths [:vector field-path-schema]]
     [:runtime-field-paths [:vector field-path-schema]]]]
   [:filters
    [:map {:description "Applied selections by field path."}
     [:by-field-path [:map-of field-path-schema field-filter-schema]]]]
   [:facets
    [:map {:description "Facet option results and loading/error states by field path."}
     [:by-field-path [:map-of field-path-schema [:vector [:map
                                                          [:value any?]
                                                          [:label {:optional true} string?]
                                                          [:count {:optional true} any?]]]]]
     [:baseline-by-field-path [:map-of field-path-schema [:vector [:map
                                                                   [:value any?]
                                                                   [:label {:optional true} string?]
                                                                   [:count {:optional true} any?]]]]]
     [:loading-by-field-path [:map-of field-path-schema boolean?]]
     [:error-by-field-path [:map-of field-path-schema any?]]
     [:has-more-by-field-path [:map-of field-path-schema boolean?]]
     [:next-offset-by-field-path [:map-of field-path-schema [:maybe int?]]]]]
   [:callbacks
    [:map {:description "Events provided by parent container for external data loading."}
     [:load-facets-event {:optional true} [:maybe [:vector any?]]]
     [:on-changed-event {:optional true} [:maybe [:vector any?]]]]]
   [:ui
    [:map {:description "Local interaction state for pickers/editors."}
     [:open-field-path {:optional true} [:maybe field-path-schema]]
     [:field-picker-open? boolean?]
     [:field-picker-search-text string?]
     [:option-search-text-by-field [:map-of field-path-schema string?]]
     [:busy-by-key [:map-of keyword? boolean?]]]]])
